const single_sign_on = {
    forbidden_domains: 'Genel e-posta alanı domainleri izin verilmiyor.',
    duplicated_domains: 'Yinelenmiş domainler bulunmaktadır.',
    invalid_domain_format: 'Geçersiz domain formatı.',
    duplicate_connector_name: 'Bağlayıcı adı zaten var. Lütfen farklı bir ad seçin.',
};
export default Object.freeze(single_sign_on);
